import { isEditorLive } from '@heidi/editor/core';
import { type Editor } from '@tiptap/react';

// Static asset under /public, not a backend route.
export const PCM_WORKLET_MODULE_URL = '/dictation/pcm-processor.js';

export function discardMediaStream(stream: MediaStream | null | undefined) {
  stream?.getTracks().forEach((track) => {
    track.stop();
    track.enabled = false;
  });
}

export function isDictationStartCancelled(
  currentGeneration: number,
  startGeneration: number,
  boundEditor: Editor | null,
  editor: Editor
) {
  return (
    currentGeneration !== startGeneration ||
    boundEditor !== editor ||
    !isEditorLive(editor, 'dictateRecorderShared.isDictationStartCancelled')
  );
}

export function takeLiveAcquiredStream(
  stream: MediaStream,
  currentGeneration: number,
  startGeneration: number,
  boundEditor: Editor | null,
  editor: Editor
): MediaStream | null {
  if (
    isDictationStartCancelled(currentGeneration, startGeneration, boundEditor, editor)
  ) {
    discardMediaStream(stream);
    return null;
  }
  return stream;
}
